import * as React from 'react';
import { connect } from 'react-redux';

import ActionButton from 'components/buttons/action-button/ActionButton';
import ShippingStepMessage from './ShippingStepMessage';

import { t } from 'utils/language';
import { prepareSettingsPayload } from 'utils/organization';
import { saveOrganizationSettings } from 'modules/organizations/reducers/organizationSettings';

import type { OrganizationSettingsForm, OrganizationSettingsParams } from 'types';

type OwnProps = {
  subcampaignId: number,
  settingsId: number,
  minHeight: number,
  organizationSettings: OrganizationSettingsForm,
  buttonText?: string,
  onCancel: () => void,
  onClose: () => void
};

type DispatchProps = {
  dispatchSaveOrganizationSettings: (id: number, data: OrganizationSettingsForm, params: OrganizationSettingsParams) => Promise<void>
};

type Props = OwnProps & DispatchProps;

class ShippingStepBusinessDetailsMissing extends React.PureComponent<Props> {
  handleNotifyBusinessDetailsAreMissing = () => {
    const { organizationSettings, settingsId, subcampaignId, onClose, dispatchSaveOrganizationSettings } = this.props;
    const trimmedPayload = prepareSettingsPayload(organizationSettings);

    dispatchSaveOrganizationSettings(settingsId, trimmedPayload, {
      subcampaignId,
      // Specify updateType for sending System Message
      updateType: 'business_details_missing'
    })
      .then(() => onClose())
      .catch(() => {});
  };

  render(): React.ReactNode {
    const { buttonText, minHeight, onCancel } = this.props;

    return (
      <ShippingStepMessage
        minHeight={minHeight}
        body={{
          main: t('shipping_address.provide_business_details'),
          sub: t('shipping_address.inform_team')
        }}
        actions={[
          <ActionButton
            color="tertiary"
            onClick={onCancel}
            key="button-back"
          >
            {t('shipping_address.button_cancel')}
          </ActionButton>,
          <ActionButton
            onClick={this.handleNotifyBusinessDetailsAreMissing}
            key="button-ok"
          >
            {buttonText || t('shipping_address.button_continue')}
          </ActionButton>
        ]}
      />
    );
  }
}

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchSaveOrganizationSettings: (id: number, data: OrganizationSettingsForm, params: OrganizationSettingsParams) => dispatch(saveOrganizationSettings(id, data, params))
});

export default connect(null, mapDispatchToProps)(ShippingStepBusinessDetailsMissing);
